export default ".grid {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n}";